import React, { useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
export const ChatRobot = () => {
  const [showCode, setShowCode] = useState(false);
  const [imgloading, setImgloading] = useState(false);
  const [imgSrc, setImgSrc] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    const imgDom = new Image();
    setImgloading(true);
    imgDom.src = "//files.authing.co/authing-website/wechat-rebot-code.png";
    imgDom.onload = function () {
      setImgloading(false);
      setImgSrc(imgDom.src);
    };
  }, []);
  const LodingRender = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          paddingTop: "34px",
        }}
      >
        <ReactLoading
          type="spinningBubbles"
          color="#396aff"
          height={40}
          width={40}
        />
      </div>
    );
  };
  const ChatRobotPc = () => {
    return (
      <div className="wechat-robot-box">
        <div
          className="wechat-robot-closed"
          onClick={() => {
            setShowCode(!showCode);
          }}
        >
          <i className="icon authing-icon authing-customer-service-2-fill"></i>
        </div>
        {showCode && (
          <div className="wechat-robot-content">
            <div className="wechat-robot-reqcode">
              {imgloading ? LodingRender() : <img src={imgSrc} alt="authing" />}
            </div>
            <div className="text">
              {t("common.chatrobot.scan")}
              <span style={{ color: "#396aff" }}>
                {t("common.chatrobot.privateService")}
              </span>
            </div>
            <div className="text"> {t("common.chatrobot.support")}</div>
          </div>
        )}
      </div>
    );
  };
  const ChatRobotMobile = () => {
    return (
      <div className="wechat-robot-box-mobile">
        <a
          className="wechat-robot-closed"
          href="https://work.weixin.qq.com/kfid/kfccc209d271cb6e3c0"
          //   target="_blank"
          //   rel="noopener noreferrer"
        >
          <i className="icon authing-icon authing-customer-service-2-fill"></i>
        </a>
      </div>
    );
  };
  return (
    <>
      {ChatRobotPc()}
      {ChatRobotMobile()}
    </>
  );
};
